<template>
  <div class="smart">
    <div class="keys" v-show="isLogin">
      <div class="box">
        <strong>品类：</strong>
        <div class="row">
          <a class="all" href="javascription:;">全部</a>
          <div class="item" v-for="(item, k) in categorys" :key="k">
            <a href="javascription:;" @click="getCatProducts(item.id)">{{ item.name }}</a>
            <i class="el-icon-delete-solid" @click="delCat(item.id)" />
          </div>
          <a href="javascription:;" @click="openAddCategory">
            <i class="el-icon-document-add" />
          </a>
        </div>
      </div>
      <div class="box">
        <strong>通信方式：</strong>
        <div class="row">
          <a class="all" href="javascription:;">全部</a>
          <div class="item" v-for="(item, k) in keywords" :key="k">
            <a href="javascription:;" @click="getKeyProducts(item.name)">{{ item.name }}</a>
            <i class="el-icon-delete-solid" @click="delKW(item.id)" />
          </div>
          <a href="javascription:;" @click="openAddKeyword">
            <i class="el-icon-document-add" />
          </a>
        </div>
      </div>
    </div>
    <div class="keys" v-show="!isLogin">
      <div class="box">
        <strong>品类：</strong>
        <div class="row">
          <a class="all" href="javascription:;">全部</a>
          <a href="javascription:;" v-for="(item, k) in categorys" :key="k" @click="getCatProducts(item.id)">{{ item.name }}</a>
        </div>
      </div>
      <div class="box">
        <strong>通信方式：</strong>
        <div class="row">
          <a class="all" href="javascription:;">全部</a>
          <a href="javascription:;" v-for="(item, k) in keywords" :key="k" @click="getKeyProducts(item.name)">{{ item.name }}</a>
        </div>
      </div>
    </div>
    <div class="items">
      <a class="item" href="#" v-for="(item, k) in lists" :key="k" :style="k % 4 == 0 ? `margin-left: 0;` : null">
        <span class="img">
          <img :src="`http://www.lelight.cn/php/class/${item.file_path}`" v-show="!!item.file_path" />
          <i class="el-icon-picture-outline" v-show="!item.file_path" />
        </span>
        <div class="info">
          <span class="title" v-text="item.title" />
          <span class="subtitle" v-text="item.subtitle" />
        </div>
        <Button class="btn-edit" type="primary" size="mini" icon="el-icon-edit" circle @click="onEdit(item)" v-show="isLogin" />
        <Button class="btn-del" type="danger" size="mini" icon="el-icon-delete" circle @click="onDelete(item.id)" v-show="isLogin" />
      </a>
      <a class="item" href="javascript:;" style="margin-right: 0" @click="onOpen" v-show="isLogin">
        <i class="el-icon-document-add" v-show="1" />
      </a>
    </div>
    <div class="page" v-show="0">
      <Pagination background layout="prev, pager, next" :total="1000" />
    </div>

    <!-- 产品 -->
    <Form ref="form" :model="form" label-width="80px">
      <Dialog title="添加产品" :visible.sync="visible" width="30%" :before-close="handleClose">
        <FormItem label="分类">
          <Select v-model="form.sid" placeholder="请选择分类">
            <Option label="默认" :value="0" />
            <Option v-for="(item, i) in categorys" :key="i" :label="item.name" :value="item.id" />
          </Select>
        </FormItem>
        <FormItem label="标题">
          <Input v-model="form.title" />
        </FormItem>
        <FormItem label="副标题">
          <Input v-model="form.subtitle" />
        </FormItem>
        <FormItem label="展示图">
          <Input v-model="form.file_path" disabled />
        </FormItem>
        <FormItem label="图片上传">
          <Upload class="upload-demo" action="http://www.lelight.cn/php/class/controller.php" name="files[]" :drag="true" :multiple="true" :show-file-list="false" :on-success="handleSuccess">
            <i class="el-icon-upload" />
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传 docx 文件，且不超过 50MB</div>
          </Upload>
        </FormItem>
        <FormItem label="关键字">
          <Input v-model="form.keywords" />
        </FormItem>
        <FormItem slot="footer" class="dialog-footer">
          <Button type="primary" @click="onSubmit">确 定</Button>
          <Button @click="visible = false">取 消</Button>
        </FormItem>
      </Dialog>
    </Form>

    <!-- 关键字 -->
    <Form ref="form" label-width="80px">
      <Dialog title="添加关键字" :visible.sync="visible2" width="30%" :before-close="handleClose">
        <FormItem label="关键字">
          <Input v-model="keyword" />
        </FormItem>
        <FormItem slot="footer" class="dialog-footer">
          <Button type="primary" @click="onSubmit2">确 定</Button>
          <Button @click="visible2 = false">取 消</Button>
        </FormItem>
      </Dialog>
    </Form>

    <!-- 分类 -->
    <Form ref="form" label-width="80px">
      <Dialog title="添加品类" :visible.sync="visible3" width="30%" :before-close="handleClose">
        <FormItem label="品类">
          <Input v-model="category" />
        </FormItem>
        <FormItem slot="footer" class="dialog-footer">
          <Button type="primary" @click="onSubmit3">确 定</Button>
          <Button @click="visible3 = false">取 消</Button>
        </FormItem>
      </Dialog>
    </Form>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';
import { Dialog, Form, FormItem, Input, Upload, Select, Option, Button, Message, Pagination } from 'element-ui';
import { getProducts, addProducts, editProducts, delProducts } from '@/utils/service';
import { getKeyword, addKeyword, delKeyword } from '@/utils/service';
import { getCategory, addCategory, delCategory } from '@/utils/service';

export default {
  name: 'smart',
  components: { Dialog, Form, FormItem, Input, Upload, Select, Option, Button, Pagination },
  data() {
    return {
      isMobile: _isMobile(),
      isLogin: false,

      // 产品
      visible: false,
      form: { id: 0, title: '', subtitle: '', file_path: '', keywords: '', sid: 0 },
      lists: [],

      // 关键字
      visible2: false,
      keywords: [],
      keyword: '',

      // 分类
      visible3: false,
      categorys: [],
      category: '',
    };
  },
  mounted() {
    const authority = sessionStorage.getItem('authority');
    this.isLogin = Boolean(authority === 'admin');

    this.getProducts();
    this.getKeywords();
    this.getCategorys();
  },
  methods: {
    // 按品类查询
    getCatProducts: async function (sid) {
      const responst = await getProducts({ sid });
      if (responst.status) this.lists = responst.data;
      else this.lists = [];
    },
    // 按关键字查询
    getKeyProducts: async function (keywords) {
      const responst = await getProducts({ keywords });
      if (responst.status) this.lists = responst.data;
      else this.lists = [];
    },
    // 分页查询
    getProducts: async function (offset = 0, limit = 10) {
      const responst = await getProducts({ offset, limit });
      if (responst.status) this.lists = responst.data;
      else this.lists = [];
    },
    onOpen() {
      this.form = { id: 0, title: '', subtitle: '', file_path: '', keywords: '', sid: 0 };
      this.visible = true;
    },
    handleClose: function () {
      this.visible = false;
      this.visible2 = false;
    },
    async onSubmit() {
      let response;
      if (this.form.id === 0) {
        delete this.form.id;
        response = await addProducts(this.form);
      } else {
        response = await editProducts(this.form);
      }

      if (response.status) {
        this.form = { id: 0, title: '', subtitle: '', file_path: '', keywords: '', sid: 0 };
        this.visible = false;
        this.getProducts();
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.status) {
        const { content, path } = response.data[0];
        this.form.file_path = path;
        Message({ message: '文件上传成功', type: 'success' });
        if (response.status) this.getProducts();
      } else {
        Message.error('文件上传失败');
      }
    },
    onEdit: function (data) {
      const { id, title, subtitle, file_path, keywords, sid } = data;
      this.visible = true;
      this.form = { id, title, subtitle, file_path, keywords, sid };
    },
    onDelete: async function (id) {
      const response = await delProducts({ id });
      if (response.status) this.getProducts();
    },

    // 关键字处理
    getKeywords: async function () {
      const responst = await getKeyword();
      if (responst.status) this.keywords = responst.data;
      else this.keywords = [];
    },
    openAddKeyword: function () {
      this.visible2 = true;
      this.keyword = '';
    },
    async onSubmit2() {
      const response = await addKeyword({ name: this.keyword });
      if (response.status) {
        this.visible2 = false;
        this.getKeywords();
      }
    },
    delKW: async function (id) {
      const response = await delKeyword({ id });
      if (response.status) this.getKeywords();
    },

    // 分类处理
    getCategorys: async function () {
      const responst = await getCategory({ sid: 1 });
      if (responst.status) this.categorys = responst.data;
      else this.categorys = [];
    },
    openAddCategory: function () {
      this.visible3 = true;
      this.category = '';
    },
    async onSubmit3() {
      const response = await addCategory({ name: this.category, level: 1, sid: 1 });
      if (response.status) {
        this.visible3 = false;
        this.getCategorys();
      }
    },
    delCat: async function (id) {
      const response = await delCategory({ id });
      if (response.status) this.getCategorys();
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
